module.exports = __webpack_public_path__ + "img/position.368ad06b.png";